import { Inject, Injectable } from '@angular/core';
import {
    CorporateInformationComponent,
    MenuEntryModel,
    MenuSectionModel,
    ReportIssueComponent,
    ReportIssueModel,
    SideMenuInterface,
    SideMenuService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaceSideMenuService implements SideMenuInterface {
    public isInitialized = false;
    public escalationEmail$: Observable<string>;
    public constructor(
        @Inject(LogInstanceToken) protected readonly log: LogInterface,
        private readonly sideMenuService: SideMenuService,
        private readonly modalService: BsModalService,
        private readonly translate: TranslateService,
    ) {}

    public init(): Observable<void> {
        const menuSection = new MenuSectionModel('');

        const corporateInformationEntry = new MenuEntryModel(
            <string>this.translate.instant('SIDE_MENU_BUTTON_CORPORATE_INFORMATION'),
            () => this.openCorporateInfo(),
        );

        const reportIssueEntry = new MenuEntryModel(
            <string>this.translate.instant('SIDE_MENU_BUTTON_REPORT_ISSUE'),
            () => this.openReportIssue(),
        );

        menuSection.entries.push(corporateInformationEntry, reportIssueEntry);
        this.sideMenuService.addSection(menuSection);
        this.isInitialized = true;

        return of(undefined);
    }

    private openCorporateInfo(): void {
        this.modalService.show(CorporateInformationComponent, {
            backdrop: 'static',
            class: 'modal-md',
            ariaLabelledBy: 'corporate-information-modal-title',
        });
    }

    private openReportIssue(): void {
        this.modalService.show(ReportIssueComponent, {
            backdrop: 'static',
            class: 'modal-lg modal-fullscreen-lg-down',
            initialState: {
                model: new ReportIssueModel(),
            },
            ariaLabelledBy: 'report-issue-modal-title',
        });
    }
}
